(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asket-editorial-blog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asket-editorial-blog')) {
    class AsketEditorialBlog extends HTMLElement {
      connectedCallback() {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplayVideos = this.dataset.autoplay === 'true';
        this.loop = this.dataset.loop === 'true';
        this.autoAdvance = this.dataset.autoAdvance === 'true' && !this.reducedMotion;
        this.interval = Math.max(3000, Number(this.dataset.interval) || 6000);
        this.isOpen = this.dataset.open !== 'false';

        this.track = this.querySelector('[data-aeb-track]');
        this.viewport = this.querySelector('[data-aeb-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-aeb-slide]'));
        this.prevButton = this.querySelector('[data-aeb-prev]');
        this.nextButton = this.querySelector('[data-aeb-next]');
        this.counter = this.querySelector('[data-aeb-current]');
        this.current = 0;
        this.hoverPaused = false;
        this.editorPaused = false;
        this.inView = false;

        this.setupCollapse();
        this.setupSlider();
        this.setupVideos();
        this.setupVisibility();
        this.setupEditor();
        this.updateControls();
      }

      disconnectedCallback() {
        this.stopTimer();
        this.observer?.disconnect();
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }

      /* ---------- Collapse ---------- */
      setupCollapse() {
        this.toggle = this.querySelector('[data-aeb-toggle]');
        this.panel = this.querySelector('[data-aeb-panel]');
        this.toggle?.addEventListener('click', () => this.setOpen(!this.isOpen));
      }

      setOpen(open) {
        if (!this.toggle || open === this.isOpen) return;
        this.isOpen = open;
        this.dataset.open = String(open);
        this.toggle.setAttribute('aria-expanded', String(open));
        if (this.panel) this.panel.inert = !open;
        this.syncVideos();
        this.startTimer();
      }

      /* ---------- Slider ---------- */
      setupSlider() {
        if (this.slides.length < 2) return;

        this.prevButton?.addEventListener('click', () => this.step(-1, true));
        this.nextButton?.addEventListener('click', () => this.step(1, true));

        this.addEventListener('keydown', (event) => {
          if (!this.viewport?.contains(event.target) && !event.target.closest?.('.aeb__controls')) return;
          if (event.target.closest?.('input, textarea')) return;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(1, true);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(-1, true);
          }
        });

        // Swipe on touch screens
        let startX = 0;
        let startY = 0;
        let tracking = false;
        this.viewport?.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          tracking = true;
          startX = event.clientX;
          startY = event.clientY;
        });
        const finish = (event) => {
          if (!tracking) return;
          tracking = false;
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.step(dx < 0 ? 1 : -1, true);
        };
        this.viewport?.addEventListener('pointerup', finish);
        this.viewport?.addEventListener('pointercancel', () => (tracking = false));

        // Auto-advance pauses while the visitor is reading or pointing at it
        const slider = this.querySelector('[data-aeb-slider]');
        slider?.addEventListener('mouseenter', () => {
          this.hoverPaused = true;
          this.stopTimer();
        });
        slider?.addEventListener('mouseleave', () => {
          this.hoverPaused = false;
          this.startTimer();
        });
        slider?.addEventListener('focusin', () => {
          this.hoverPaused = true;
          this.stopTimer();
        });
        slider?.addEventListener('focusout', (event) => {
          if (slider.contains(event.relatedTarget)) return;
          this.hoverPaused = false;
          this.startTimer();
        });
      }

      step(direction, fromUser = false) {
        const last = this.slides.length - 1;
        let next = this.current + direction;
        if (next > last) next = this.loop ? 0 : last;
        if (next < 0) next = this.loop ? last : 0;
        this.goTo(next);
        if (fromUser) this.startTimer();
      }

      goTo(index) {
        if (index === this.current || !this.slides[index]) return;
        this.current = index;
        this.track?.style.setProperty('--index', index);
        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
        });
        if (this.counter) this.counter.textContent = String(index + 1);
        this.updateControls();
        this.syncVideos();
      }

      updateControls() {
        if (this.loop) return;
        if (this.prevButton) this.prevButton.disabled = this.current <= 0;
        if (this.nextButton) this.nextButton.disabled = this.current >= this.slides.length - 1;
      }

      startTimer() {
        this.stopTimer();
        if (!this.autoAdvance || this.slides.length < 2) return;
        if (!this.isOpen || !this.inView || this.hoverPaused || this.editorPaused || document.hidden) return;
        this.timer = setInterval(() => {
          if (!this.loop && this.current >= this.slides.length - 1) {
            this.goTo(0);
          } else {
            this.step(1);
          }
        }, this.interval);
      }

      stopTimer() {
        clearInterval(this.timer);
        this.timer = null;
      }

      setupVisibility() {
        const slider = this.querySelector('[data-aeb-slider]');
        if (!slider) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            this.inView = entries[0].isIntersecting;
            this.syncVideos();
            this.startTimer();
          },
          { threshold: 0.2 }
        );
        this.observer.observe(slider);
        document.addEventListener('visibilitychange', () => this.startTimer());
      }

      /* ---------- Videos: only the visible story plays ---------- */
      setupVideos() {
        this.videos = this.slides
          .map((slide) => {
            const media = slide.querySelector('[data-aeb-video]');
            if (!media) return null;
            return {
              slide,
              video: media.querySelector('video'),
              button: media.querySelector('[data-aeb-video-toggle]'),
              userPaused: this.reducedMotion,
            };
          })
          .filter(Boolean);

        this.videos.forEach((entry) => {
          entry.button?.addEventListener('click', () => {
            entry.userPaused = !entry.userPaused;
            this.syncVideos();
          });
        });
      }

      syncVideos() {
        this.videos?.forEach((entry) => {
          if (!entry.video) return;
          const isCurrent = this.slides.indexOf(entry.slide) === this.current;
          if (!this.autoplayVideos) {
            if (!isCurrent || !this.isOpen) entry.video.pause();
            return;
          }
          const shouldPlay = this.isOpen && this.inView && isCurrent && !entry.userPaused;
          if (shouldPlay) {
            entry.video.muted = true;
            const attempt = entry.video.play();
            if (attempt && typeof attempt.catch === 'function') {
              attempt.catch(() => this.setVideoButton(entry, false));
            }
          } else {
            entry.video.pause();
          }
          this.setVideoButton(entry, !entry.userPaused);
        });
      }

      setVideoButton(entry, playing) {
        if (!entry.button) return;
        entry.button.dataset.state = playing ? 'playing' : 'paused';
        entry.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      /* ---------- Theme editor ---------- */
      setupEditor() {
        this.handleSectionSelect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.setOpen(true);
        };
        this.handleBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          this.setOpen(true);
          this.editorPaused = true;
          this.stopTimer();
          const slide = event.target.closest?.('[data-aeb-slide]');
          const index = this.slides.indexOf(slide);
          if (index > -1) this.goTo(index);
        };
        this.handleBlockDeselect = () => {
          this.editorPaused = false;
          this.startTimer();
        };
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }
    }

    customElements.define('asket-editorial-blog', AsketEditorialBlog);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asket-editorial-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asket-editorial')) {
    class AsketEditorial extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-aeh-toggle]');
        this.panel = this.querySelector('[data-aeh-panel]');
        this.isOpen = this.dataset.open !== 'false';
        this.autoplay = this.dataset.autoplay === 'true';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.handleToggle = () => this.setOpen(!this.isOpen);
        this.toggle?.addEventListener('click', this.handleToggle);

        // Theme editor: open the section when it or one of its blocks is selected
        this.handleSectionSelect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.setOpen(true);
        };
        this.handleBlockSelect = (event) => {
          if (this.contains(event.target)) this.setOpen(true);
        };
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.setupVideos();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      setOpen(open) {
        if (!this.toggle || open === this.isOpen) return;
        this.isOpen = open;
        this.dataset.open = String(open);
        this.toggle.setAttribute('aria-expanded', String(open));
        if (this.panel) this.panel.inert = !open;
        this.videos?.forEach((item) => this.syncVideo(item));
      }

      /* ---------- Videos: play only while open and on screen ---------- */
      setupVideos() {
        this.videos = Array.from(this.querySelectorAll('[data-aeh-video]')).map((wrap) => ({
          wrap,
          video: wrap.querySelector('video'),
          button: wrap.querySelector('[data-aeh-video-toggle]'),
          inView: false,
          userPaused: this.reducedMotion,
        }));

        if (!this.videos.length) return;

        this.videos.forEach((item) => {
          item.button?.addEventListener('click', () => {
            item.userPaused = !item.userPaused;
            this.syncVideo(item);
          });
        });

        if (!this.autoplay) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const item = this.videos.find((v) => v.wrap === entry.target);
              if (!item) return;
              item.inView = entry.isIntersecting;
              this.syncVideo(item);
            });
          },
          { threshold: 0.15 }
        );

        this.videos.forEach((item) => this.observer.observe(item.wrap));
      }

      syncVideo(item) {
        if (!item.video) return;

        if (!this.autoplay) {
          if (!this.isOpen) item.video.pause();
          return;
        }

        const shouldPlay = this.isOpen && item.inView && !item.userPaused;
        if (shouldPlay) {
          item.video.muted = true;
          const attempt = item.video.play();
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => this.setVideoButton(item, false));
          }
        } else {
          item.video.pause();
        }
        this.setVideoButton(item, !item.userPaused);
      }

      setVideoButton(item, playing) {
        if (!item.button) return;
        item.button.dataset.state = playing ? 'playing' : 'paused';
        item.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }
    }

    customElements.define('asket-editorial', AsketEditorial);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asket-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asket-hero-media')) {
    class AsketHeroMedia extends HTMLElement {
      connectedCallback() {
        this.wraps = Array.from(this.querySelectorAll('[data-device]'));
        if (!this.wraps.length) return;

        this.autoplay = this.dataset.autoplay === 'true';
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.toggle = this.querySelector('[data-video-toggle]');
        this.userPaused = this.reducedMotion.matches; // no motion unless the visitor presses play
        this.inView = false;

        this.handleChange = () => this.sync();
        this.desktop.addEventListener('change', this.handleChange);

        this.handleToggle = () => {
          this.userPaused = !this.userPaused;
          this.sync();
        };
        this.toggle?.addEventListener('click', this.handleToggle);

        // Only play while on screen — saves battery and data
        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.desktop?.removeEventListener('change', this.handleChange);
      }

      activeVideo() {
        const device = this.desktop.matches ? 'desktop' : 'mobile';
        const wrap = this.wraps.find((el) => el.dataset.device === device || el.dataset.device === 'all');
        return wrap?.querySelector('video') || null;
      }

      sync() {
        const active = this.activeVideo();

        this.wraps.forEach((wrap) => {
          const video = wrap.querySelector('video');
          if (video && video !== active) video.pause();
        });

        if (!active || !this.autoplay) return;

        if (!this.userPaused && this.inView) {
          active.muted = true;
          const attempt = active.play();
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => this.setToggleState(false));
          }
          this.setToggleState(true);
        } else {
          active.pause();
          this.setToggleState(!this.userPaused);
        }
      }

      setToggleState(playing) {
        if (!this.toggle) return;
        this.toggle.dataset.state = playing ? 'playing' : 'paused';
        this.toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }
    }

    customElements.define('asket-hero-media', AsketHeroMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asket-lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asket-lookbook')) {
    class AsketLookbook extends HTMLElement {
      connectedCallback() {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true';
        this.loop = this.dataset.loop === 'true';
        this.isOpen = this.dataset.open !== 'false';

        this.setupCollapse();
        this.setupSlider();
        this.setupVideos();
        this.setupEditor();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      /* ---------- Collapse ---------- */
      setupCollapse() {
        this.toggle = this.querySelector('[data-alb-toggle]');
        this.panel = this.querySelector('[data-alb-panel]');
        this.toggle?.addEventListener('click', () => this.setOpen(!this.isOpen));
      }

      setOpen(open) {
        if (!this.toggle || open === this.isOpen) return;
        this.isOpen = open;
        this.dataset.open = String(open);
        this.toggle.setAttribute('aria-expanded', String(open));
        if (this.panel) this.panel.inert = !open;
        this.syncVideos();
      }

      /* ---------- Slider ---------- */
      setupSlider() {
        this.frame = this.querySelector('[data-alb-slider]');
        this.track = this.querySelector('[data-alb-track]');
        this.slides = Array.from(this.querySelectorAll('[data-alb-slide]'));
        this.counter = this.querySelector('[data-alb-current]');
        this.prevButton = this.querySelector('[data-alb-prev]');
        this.nextButton = this.querySelector('[data-alb-next]');
        this.current = 0;
        if (!this.track || this.slides.length < 2) return;

        this.prevButton?.addEventListener('click', () => this.step(-1));
        this.nextButton?.addEventListener('click', () => this.step(1));

        this.track.addEventListener(
          'scroll',
          () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = null;
              this.setCurrent(this.indexFromScroll());
            });
          },
          { passive: true }
        );

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(-1);
          }
        });

        this.resizeObserver = new ResizeObserver(() => {
          this.track.scrollTo({ left: this.offsetOf(this.current), behavior: 'auto' });
          this.updateControls();
        });
        this.resizeObserver.observe(this.track);

        this.updateControls();
      }

      offsetOf(index) {
        return this.slides[index].offsetLeft - this.slides[0].offsetLeft;
      }

      perView() {
        const stepWidth = this.offsetOf(1) || 1;
        return Math.max(1, Math.round((this.track.clientWidth + this.gap()) / stepWidth));
      }

      gap() {
        return parseFloat(getComputedStyle(this.track).columnGap) || 0;
      }

      maxIndex() {
        return Math.max(0, this.slides.length - this.perView());
      }

      indexFromScroll() {
        const left = this.track.scrollLeft;
        let closest = 0;
        let distance = Infinity;
        this.slides.forEach((_, i) => {
          const d = Math.abs(this.offsetOf(i) - left);
          if (d < distance) {
            distance = d;
            closest = i;
          }
        });
        return Math.min(closest, this.maxIndex());
      }

      step(direction) {
        const max = this.maxIndex();
        let next = this.current + direction;
        if (next > max) next = this.loop ? 0 : max;
        if (next < 0) next = this.loop ? max : 0;
        this.goTo(next);
      }

      goTo(index, instant = false) {
        const target = Math.max(0, Math.min(index, this.maxIndex()));
        this.track.scrollTo({
          left: this.offsetOf(target),
          behavior: instant || this.reducedMotion ? 'auto' : 'smooth',
        });
        this.setCurrent(target);
      }

      setCurrent(index) {
        if (index === this.current && this.initialised) return;
        this.initialised = true;
        this.current = index;
        if (this.counter) this.counter.textContent = String(index + 1);
        this.updateControls();
        this.syncVideos();
      }

      updateControls() {
        const max = this.maxIndex();
        this.frame?.classList.toggle('is-static', max === 0);
        if (!this.loop) {
          if (this.prevButton) this.prevButton.disabled = this.current <= 0;
          if (this.nextButton) this.nextButton.disabled = this.current >= max;
        }
      }

      /* ---------- Videos: play the slides in view ---------- */
      setupVideos() {
        this.videos = this.slides
          .filter((slide) => slide.hasAttribute('data-alb-video'))
          .map((slide) => ({
            slide,
            video: slide.querySelector('video'),
            button: slide.querySelector('[data-alb-video-toggle]'),
            userPaused: this.reducedMotion,
          }));

        if (!this.videos.length) return;

        this.videos.forEach((item) => {
          item.button?.addEventListener('click', () => {
            item.userPaused = !item.userPaused;
            this.syncVideos();
          });
        });

        this.inView = false;
        this.observer = new IntersectionObserver(
          (entries) => {
            this.inView = entries[0].isIntersecting;
            this.syncVideos();
          },
          { threshold: 0.2 }
        );
        if (this.frame) this.observer.observe(this.frame);
      }

      syncVideos() {
        if (!this.videos?.length) return;
        const perView = this.slides.length > 1 ? this.perView() : 1;
        this.videos.forEach((item) => {
          if (!item.video) return;
          const index = this.slides.indexOf(item.slide);
          const visible = index >= this.current && index < this.current + perView;

          if (!this.autoplay) {
            if (!visible || !this.isOpen) item.video.pause();
            return;
          }

          const shouldPlay = this.isOpen && this.inView && visible && !item.userPaused;
          if (shouldPlay) {
            item.video.muted = true;
            const attempt = item.video.play();
            if (attempt && typeof attempt.catch === 'function') {
              attempt.catch(() => this.setVideoButton(item, false));
            }
          } else {
            item.video.pause();
          }
          this.setVideoButton(item, !item.userPaused);
        });
      }

      setVideoButton(item, playing) {
        if (!item.button) return;
        item.button.dataset.state = playing ? 'playing' : 'paused';
        item.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      /* ---------- Theme editor ---------- */
      setupEditor() {
        this.handleSectionSelect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.setOpen(true);
        };
        this.handleBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          this.setOpen(true);
          const slide = event.target.closest?.('[data-alb-slide]');
          const index = this.slides.indexOf(slide);
          if (index > -1 && this.slides.length > 1) this.goTo(index, true);
        };
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    customElements.define('asket-lookbook', AsketLookbook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asket-product-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asket-product-editorial')) {
    class AsketProductEditorial extends HTMLElement {
      connectedCallback() {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true';
        this.isOpen = this.dataset.open !== 'false';

        this.setupCollapse();
        this.setupSlider();
        this.setupVideos();
        this.setupSwatches();
        this.setupEditor();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      /* ---------- Collapse ---------- */
      setupCollapse() {
        this.toggle = this.querySelector('[data-ape-toggle]');
        this.panel = this.querySelector('[data-ape-panel]');
        this.toggle?.addEventListener('click', () => this.setOpen(!this.isOpen));
      }

      setOpen(open) {
        if (!this.toggle || open === this.isOpen) return;
        this.isOpen = open;
        this.dataset.open = String(open);
        this.toggle.setAttribute('aria-expanded', String(open));
        if (this.panel) this.panel.inert = !open;
        this.syncVideos();
      }

      /* ---------- Slider ---------- */
      setupSlider() {
        this.track = this.querySelector('[data-ape-track]');
        this.slides = Array.from(this.querySelectorAll('[data-ape-slide]'));
        this.counter = this.querySelector('[data-ape-current]');
        this.current = 0;
        if (!this.track || this.slides.length < 2) return;

        this.querySelector('[data-ape-prev]')?.addEventListener('click', () => this.goTo(this.current - 1));
        this.querySelector('[data-ape-next]')?.addEventListener('click', () => this.goTo(this.current + 1));

        this.track.addEventListener(
          'scroll',
          () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = null;
              const width = this.track.clientWidth || 1;
              const index = Math.round(this.track.scrollLeft / width);
              if (index !== this.current) this.setCurrent(index);
            });
          },
          { passive: true }
        );

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.current + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.current - 1);
          }
        });

        // Keep the current slide in place when the layout width changes
        this.resizeObserver = new ResizeObserver(() => {
          this.track.scrollTo({ left: this.current * this.track.clientWidth, behavior: 'auto' });
        });
        this.resizeObserver.observe(this.track);
      }

      goTo(index, instant = false) {
        const count = this.slides.length;
        if (count < 2) return;
        const next = ((index % count) + count) % count;
        this.track.scrollTo({
          left: next * this.track.clientWidth,
          behavior: instant || this.reducedMotion ? 'auto' : 'smooth',
        });
        this.setCurrent(next);
      }

      setCurrent(index) {
        this.current = index;
        if (this.counter) this.counter.textContent = String(index + 1);
        this.slides.forEach((slide, i) => {
          slide.inert = i !== index;
        });
        this.syncVideos();
      }

      /* ---------- Videos: only the visible slide plays ---------- */
      setupVideos() {
        this.videos = this.slides
          .filter((slide) => slide.hasAttribute('data-ape-video'))
          .map((slide) => ({
            slide,
            video: slide.querySelector('video'),
            button: slide.querySelector('[data-ape-video-toggle]'),
            userPaused: this.reducedMotion,
          }));

        if (!this.videos.length) return;

        this.videos.forEach((item) => {
          item.button?.addEventListener('click', () => {
            item.userPaused = !item.userPaused;
            this.syncVideos();
          });
        });

        this.inView = false;
        this.observer = new IntersectionObserver(
          (entries) => {
            this.inView = entries[0].isIntersecting;
            this.syncVideos();
          },
          { threshold: 0.2 }
        );
        const slider = this.querySelector('[data-ape-slider]');
        if (slider) this.observer.observe(slider);
      }

      syncVideos() {
        if (!this.videos?.length) return;
        this.videos.forEach((item) => {
          if (!item.video) return;
          const isCurrent = this.slides.indexOf(item.slide) === this.current;

          if (!this.autoplay) {
            if (!isCurrent || !this.isOpen) item.video.pause();
            return;
          }

          const shouldPlay = this.isOpen && this.inView && isCurrent && !item.userPaused;
          if (shouldPlay) {
            item.video.muted = true;
            const attempt = item.video.play();
            if (attempt && typeof attempt.catch === 'function') {
              attempt.catch(() => this.setVideoButton(item, false));
            }
          } else {
            item.video.pause();
          }
          this.setVideoButton(item, !item.userPaused);
        });
      }

      setVideoButton(item, playing) {
        if (!item.button) return;
        item.button.dataset.state = playing ? 'playing' : 'paused';
        item.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      /* ---------- Color swatches: label follows the hovered swatch ---------- */
      setupSwatches() {
        this.querySelectorAll('[data-ape-color]').forEach((row) => {
          const label = row.querySelector('[data-ape-color-label]');
          if (!label) return;
          const reset = () => {
            label.textContent = label.dataset.default || '';
          };
          row.querySelectorAll('.ape__swatch').forEach((swatch) => {
            const show = () => {
              if (swatch.dataset.name) label.textContent = swatch.dataset.name;
            };
            swatch.addEventListener('mouseenter', show);
            swatch.addEventListener('focus', show);
            swatch.addEventListener('blur', reset);
          });
          row.querySelector('.ape__swatches')?.addEventListener('mouseleave', reset);
        });
      }

      /* ---------- Theme editor ---------- */
      setupEditor() {
        this.handleSectionSelect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.setOpen(true);
        };
        this.handleBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          this.setOpen(true);
          const slide = event.target.closest?.('[data-ape-slide]');
          const index = this.slides.indexOf(slide);
          if (index > -1) this.goTo(index, true);
        };
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    customElements.define('asket-product-editorial', AsketProductEditorial);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-custom"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asket-hero-media')) {
    class AsketHeroMedia extends HTMLElement {
      connectedCallback() {
        this.wraps = Array.from(this.querySelectorAll('[data-device]'));
        if (!this.wraps.length) return;

        this.autoplay = this.dataset.autoplay === 'true';
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.toggle = this.querySelector('[data-video-toggle]');
        this.userPaused = this.reducedMotion.matches; // no motion unless the visitor presses play
        this.inView = false;

        this.handleChange = () => this.sync();
        this.desktop.addEventListener('change', this.handleChange);

        this.handleToggle = () => {
          this.userPaused = !this.userPaused;
          this.sync();
        };
        this.toggle?.addEventListener('click', this.handleToggle);

        // Only play while on screen — saves battery and data
        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.desktop?.removeEventListener('change', this.handleChange);
      }

      activeVideo() {
        const device = this.desktop.matches ? 'desktop' : 'mobile';
        const wrap = this.wraps.find((el) => el.dataset.device === device || el.dataset.device === 'all');
        return wrap?.querySelector('video') || null;
      }

      sync() {
        const active = this.activeVideo();

        this.wraps.forEach((wrap) => {
          const video = wrap.querySelector('video');
          if (video && video !== active) video.pause();
        });

        if (!active || !this.autoplay) return;

        if (!this.userPaused && this.inView) {
          active.muted = true;
          const attempt = active.play();
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => this.setToggleState(false));
          }
          this.setToggleState(true);
        } else {
          active.pause();
          this.setToggleState(!this.userPaused);
        }
      }

      setToggleState(playing) {
        if (!this.toggle) return;
        this.toggle.dataset.state = playing ? 'playing' : 'paused';
        this.toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }
    }

    customElements.define('asket-hero-media', AsketHeroMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lookbook-strip')) {
    class LookbookStrip extends HTMLElement {
      connectedCallback() {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true';
        this.isOpen = this.dataset.open !== 'false';
        this.mode = this.dataset.mode === 'auto' ? 'auto' : 'free';

        this.scroller = this.querySelector('[data-lbs-scroller]');
        this.rail = this.querySelector('[data-lbs-rail]');
        this.strip = this.querySelector('[data-lbs-strip]');

        this.setupCollapse();
        if (this.mode === 'auto' && !this.reducedMotion) {
          this.setupLoop();
        } else {
          if (this.mode === 'auto') this.classList.add('is-static');
          this.setupFreeScroll();
        }
        this.setupVideos();
        this.setupEditor();
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.videoObserver?.disconnect();
        this.resizeObserver?.disconnect();
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }

      /* ---------- Collapse ---------- */
      setupCollapse() {
        this.toggle = this.querySelector('[data-lbs-toggle]');
        this.panel = this.querySelector('[data-lbs-panel]');
        this.toggle?.addEventListener('click', () => this.setOpen(!this.isOpen));
      }

      setOpen(open) {
        if (!this.toggle || open === this.isOpen) return;
        this.isOpen = open;
        this.dataset.open = String(open);
        this.toggle.setAttribute('aria-expanded', String(open));
        if (this.panel) this.panel.inert = !open;
        this.updateLoopState();
        this.syncVideos();
      }

      /* ---------- Free scroll: swipe, trackpad, drag, progress line ---------- */
      setupFreeScroll() {
        if (!this.scroller) return;
        this.progress = this.querySelector('[data-lbs-progress]');

        const update = () => {
          this.progressFrame = null;
          this.updateProgress();
        };
        this.scroller.addEventListener(
          'scroll',
          () => {
            if (!this.progressFrame) this.progressFrame = requestAnimationFrame(update);
          },
          { passive: true }
        );

        this.resizeObserver = new ResizeObserver(() => this.updateProgress());
        this.resizeObserver.observe(this.scroller);
        this.updateProgress();

        if (this.classList.contains('lbs--drag')) this.setupDrag();
      }

      updateProgress() {
        if (!this.progress || !this.scroller) return;
        const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
        const track = this.progress.parentElement.clientWidth;
        const visible = scrollWidth > 0 ? Math.min(1, clientWidth / scrollWidth) : 1;
        const thumb = Math.max(24, track * visible);
        const maxScroll = Math.max(1, scrollWidth - clientWidth);
        const x = (track - thumb) * (scrollLeft / maxScroll);
        this.progress.style.setProperty('--thumb-width', thumb + 'px');
        this.progress.style.setProperty('--thumb-x', x + 'px');
        this.progress.parentElement.hidden = visible >= 1;
      }

      setupDrag() {
        let startX = 0;
        let startScroll = 0;
        let moved = false;
        let pointerId = null;

        this.scroller.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (event.target.closest('button')) return;
          pointerId = event.pointerId;
          startX = event.clientX;
          startScroll = this.scroller.scrollLeft;
          moved = false;
        });

        this.scroller.addEventListener('pointermove', (event) => {
          if (pointerId !== event.pointerId) return;
          const delta = event.clientX - startX;
          if (!moved && Math.abs(delta) > 5) {
            moved = true;
            this.scroller.classList.add('is-dragging');
            this.scroller.setPointerCapture(pointerId);
          }
          if (moved) this.scroller.scrollLeft = startScroll - delta;
        });

        const end = (event) => {
          if (pointerId !== event.pointerId) return;
          pointerId = null;
          if (moved) {
            // Keep the click that ends a drag from opening a link
            const block = (e) => {
              e.preventDefault();
              e.stopPropagation();
            };
            this.scroller.addEventListener('click', block, { capture: true, once: true });
            setTimeout(() => this.scroller.removeEventListener('click', block, { capture: true }), 0);
          }
          this.scroller.classList.remove('is-dragging');
        };
        this.scroller.addEventListener('pointerup', end);
        this.scroller.addEventListener('pointercancel', end);
      }

      /* ---------- Auto-scroll loop ---------- */
      setupLoop() {
        if (!this.rail || !this.scroller) return;
        this.originals = Array.from(this.rail.querySelectorAll('[data-lbs-item]'));
        if (!this.originals.length) return;

        this.buildLoop();

        let lastWidth = this.scroller.clientWidth;
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.scroller.clientWidth;
          if (Math.abs(width - lastWidth) < 2) return;
          lastWidth = width;
          this.buildLoop();
        });
        this.resizeObserver.observe(this.scroller);

        this.inView = false;
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.updateLoopState();
        });
        this.visibilityObserver.observe(this.scroller);
      }

      buildLoop() {
        this.rail.querySelectorAll('[data-lbs-clone]').forEach((node) => node.remove());
        this.classList.remove('is-looping');

        const setWidth = this.rail.scrollWidth;
        if (!setWidth) return;

        // Enough copies to always cover the screen, then doubled so moving by
        // exactly half the rail makes a seamless loop.
        const setsPerHalf = Math.max(1, Math.ceil(this.scroller.clientWidth / setWidth));
        const totalSets = setsPerHalf * 2;
        const fragment = document.createDocumentFragment();
        for (let s = 1; s < totalSets; s++) {
          this.originals.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-lbs-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.inert = true;
            clone.querySelectorAll('video').forEach((video) => (video.preload = 'none'));
            fragment.appendChild(clone);
          });
        }
        this.rail.appendChild(fragment);

        const speed = Math.max(5, Number(this.dataset.speed) || 40);
        const halfWidth = setWidth * setsPerHalf;
        this.style.setProperty('--marquee-duration', (halfWidth / speed).toFixed(2) + 's');
        this.classList.add('is-looping');

        this.refreshVideos?.();
        this.updateLoopState();
      }

      updateLoopState() {
        if (!this.rail || this.mode !== 'auto') return;
        const paused = !this.isOpen || this.inView === false || this.editorPaused;
        this.rail.classList.toggle('is-paused', paused);
      }

      /* ---------- Videos: play while on screen ---------- */
      setupVideos() {
        this.refreshVideos = () => {
          this.videoObserver?.disconnect();
          this.videos = Array.from(this.querySelectorAll('[data-lbs-video]')).map((media) => {
            const item = media.closest('[data-lbs-item]');
            return {
              media,
              video: media.querySelector('video'),
              button: item?.querySelector('[data-lbs-video-toggle]'),
              inView: false,
              userPaused: this.reducedMotion,
            };
          });
          if (!this.videos.length) return;

          if (!this.autoplay) return;
          this.videoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((observed) => {
                const entry = this.videos.find((v) => v.media === observed.target);
                if (!entry) return;
                entry.inView = observed.isIntersecting;
                this.syncVideo(entry);
              });
            },
            { threshold: 0.25 }
          );
          this.videos.forEach((entry) => this.videoObserver.observe(entry.media));
        };
        // One delegated listener, so rebuilt loop copies don't stack handlers
        this.addEventListener('click', (event) => {
          const button = event.target.closest?.('[data-lbs-video-toggle]');
          if (!button || !this.videos) return;
          event.preventDefault();
          const entry = this.videos.find((v) => v.button === button);
          if (!entry) return;
          entry.userPaused = !entry.userPaused;
          this.syncVideo(entry);
        });

        this.refreshVideos();
      }

      syncVideos() {
        this.videos?.forEach((entry) => this.syncVideo(entry));
      }

      syncVideo(entry) {
        if (!entry.video) return;
        if (!this.autoplay) {
          if (!this.isOpen) entry.video.pause();
          return;
        }
        const shouldPlay = this.isOpen && entry.inView && !entry.userPaused;
        if (shouldPlay) {
          entry.video.muted = true;
          const attempt = entry.video.play();
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => this.setVideoButton(entry, false));
          }
        } else {
          entry.video.pause();
        }
        this.setVideoButton(entry, !entry.userPaused);
      }

      setVideoButton(entry, playing) {
        if (!entry.button) return;
        entry.button.dataset.state = playing ? 'playing' : 'paused';
        entry.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      /* ---------- Theme editor ---------- */
      setupEditor() {
        this.handleSectionSelect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.setOpen(true);
        };
        this.handleBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          this.setOpen(true);
          const item = event.target.closest?.('[data-lbs-item]');
          if (!item) return;
          if (this.mode === 'auto' && this.classList.contains('is-looping')) {
            this.editorPaused = true;
            this.updateLoopState();
          } else if (this.scroller) {
            const start = parseFloat(getComputedStyle(this.rail).paddingInlineStart) || 0;
            this.scroller.scrollTo({ left: item.offsetLeft - start, behavior: 'auto' });
          }
        };
        this.handleBlockDeselect = () => {
          this.editorPaused = false;
          this.updateLoopState();
        };
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }
    }

    customElements.define('lookbook-strip', LookbookStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
